import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { apply } from 'ramda';

import store from '../store';
import theme from './style/muiTheme';
import './style/stylesheets';
import TimeUtil from './TimeUtil';

const storeMiddleware = [thunk];
if (process.env.NODE_ENV !== 'production') storeMiddleware.push(logger)
const appStore = createStore(
    store,
    apply(applyMiddleware, storeMiddleware)
);

function config (WrappedComponent) {
    return function () {
        return (
            <Provider store={appStore}>
                <MuiThemeProvider theme={theme}>
                    <TimeUtil>
                        <BrowserRouter>
                            <WrappedComponent />
                        </BrowserRouter>
                    </TimeUtil>
                </MuiThemeProvider>
            </Provider>
        );
    }
}

export { config, appStore };
